<div class="tpl-destinera-modal-container">
  <div class="modal-header">
    <rask-header size="2">{{ 'TPL_DESTINERA_MODAL_HEADER' | translate }}</rask-header>
    <button type="button" class="btn-close close-x" aria-label="Close" (click)="tryClose()">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <rask-container-block>
    <div>
      <form [formGroup]="form">
        <div class="row ps-3 pe-3">
          <div class="col-8 px-0">
            <rask-label [noCol]="true">{{ 'TPL_DESTINERA_MODAL_HANDELSSORTIMENT' | translate }}</rask-label>
          </div>
          <div class="col-4 px-0">
            <rask-label [noCol]="true">{{ isVaglagerFilterActive ? 'Summa vägvolym' : 'Summa planerad volym'}}</rask-label>
            <rask-info class="mb-3">Här visas väglagervolymen, om du har filtrerat på väglager. Annars visas planerad volym</rask-info>
          </div>

        </div>
        <div class="row ps-3 pe-3">
          <label class="col-8">{{ targetHandelssortiment?.value }}</label>
          <label class="col-4">{{ summaVolym }}</label>
        </div>

        <div class="row ps-3 pe-3 mt-3">
          <rask-label size="8">{{ 'TPL_DESTINERA_MODAL_MOTTAGNINGSPLATS' | translate }}</rask-label>
          <rask-label size="4">{{ 'TPL_DESTINERA_MODAL_ANDEL' | translate }}</rask-label>
        </div>

        @for (destinering of destineringarFormArray?.controls; track $index; let i = $index) {
          <div class="row pb-3" [formGroup]="$any(destinering)"
            >
            <div class="col-8">
              <rask-selector
                formControlName="mottagningsplatsRef"
                [formatter]="tplMottagningsplatsOutputFormatter"
                [viewFormatter]="tplMottagningsplatsFormatter"
                [values]="mottagningsplatser"
                [exclude]="getDestineradeMottagningsplatser(i)"
                class="w-100 low"
                [disabled]="!canDestinera()"
                [rule]="$safeNavigationMigration(validationContext?.current['mottagningsplats'+i])">
              </rask-selector>
            </div>
            <div class="col-4 buttons input-pos">
              <rask-input-number
                class="low col-8"
                formControlName="andel"
                [placeholder]="!canSetAndel() ? '100' : ''"
                [rule]="validationContext.current['andel'+i]"
                [min]="0"
                [max]="100"
                unit="%">
              </rask-input-number>
              @if (i > 0) {
                <rask-button
                  color="tertiary"
                  icon="far fa-trash-alt"
                  (click)="remove(i)"
                  class="col-4 my-0">
                </rask-button>
              }
            </div>
          </div>
        }
        <div class="row text-danger">
          @if (totalAndel<100) {
            <div class="col-12 ms-3">Återstår att destinera {{ 100-totalAndel}}%
            </div>
          }
          @if (totalAndel>100) {
            <div class="col-12 ms-3">Total andel överstiger med
            {{ totalAndel-100}}%</div>
          }
        </div>

        @if (validationMessages?.length > 0) {
          <div>
            @for (message of validationMessages; track message) {
              <div>
                <rask-validation-message-row [type]="message.type" [message]="message.text">
                </rask-validation-message-row>
              </div>
            }
          </div>
        }

      </form>
    </div>

    <div class="action-btn-container row float-none">
      <div class="col-11">
        <rask-action-button
          (click)="addDestinering()"
          class="action-btn display-block"
          icon="fal fa-plus-circle"
          [disabled]="!canAddDestinering()">
          {{ 'TPL_DESTINERA_MODAL_LAGGTILLMOTTAGNINGSPLATS' | translate }}
        </rask-action-button>
      </div>
    </div>

    <ng-container footer>
      <div class="row mx-1">
        <div class="col-3 mx-2 px-0">
          <rask-button
            class="footer-button px-0"
            color="tertiary"
            (click) ="deleteDestineringar()"
            negative>
            Ta bort destinering
          </rask-button>
        </div>

        <div class="col-5 ms-5 px-0">
          <rask-button
            class="footer-button px-0"
            color="tertiary"
            (click)="uppdateraDestineringsalternativ()"
            [disabled]="!canDestinera()">
            {{ 'TPL_DESTINERA_UPPDATERA_DESTINERINGSALTERNATIV' | translate }}
          </rask-button>
        </div>

        <div class="col-2 px-0 save-button">
          <rask-button
            color="primary"
            class="footer-button px-0"
            (click)="save()"
            [disabled]="!canSave()">
            {{ 'DEFAULT_BUTTON_LABEL_SPARA' | translate }}
          </rask-button>
        </div>
      </div>
    </ng-container>

  </rask-container-block>
</div>